
import {Component, Prop, Vue} from 'nuxt-property-decorator'
import CollapseBlock from '@pp-frontend/shared-packages/components/CollapseBlock.vue'
import DocWidgetListItem from './DocWidgetListItem.vue'
import DocWidgetListItem2 from './DocWidgetListItem2.vue'
import DocWidgetListItem3 from './DocWidgetListItem3.vue'

@Component({
  components: {
    CollapseBlock,
    DocWidgetListItem,
    DocWidgetListItem2,
    DocWidgetListItem3
  }
})
export default class DocWidgetList extends Vue {
  @Prop({default: 'Сохраненные реквизиты'}) title!: string
  @Prop({default: 'gibdd'}) docType: 'gibdd' | 'fns' | 'fssp'
  @Prop({default: 'gos-oplata'}) project
  @Prop({ default: false }) newType: boolean

  // переключалка копонента отображения документов: 1 - вариант для гибдд(все гибдд сайты), 2 - заточен для ГО, 3 - для нового ФССП
  @Prop({default: 1}) docComponentVariant: 1 | 2 | 3

  async mounted() {
    await this.$store.dispatch('docs/getList')
  }

  get docs() {
    const sortAccrualsDesc = (a, b) => b.accrual_count - a.accrual_count
    if (this.docType === 'fns') {
      return this.$store.getters['docs/getDocBySearchType'](this.docType).filter((doc) => doc.document_type !== 'passport').sort(sortAccrualsDesc)
    } else {
      return this.$store.getters['docs/getDocBySearchType'](this.docType).sort(sortAccrualsDesc)
    }
  }

  searchByDoc(doc) {
    let query: {
      document_type: string
      document_value: string
      additional_fields?: any
      owner_name?: string
    } = {
      document_type: doc.document_type,
      document_value: doc.document_value,
    }
    if (doc.additional_fields) {
      query.additional_fields = {
        ...doc.additional_fields
      }
    }
    if (doc.owner_name) {
      query.owner_name = doc.owner_name
    }
    // @ts-ignore
    return this.$router.push({path: `/search/${this.docType}`, query})
  }
}
